import { createEnum } from "@redotech/zod/zod-enum";

export enum RedoFinderLoadType {
  FULL_PATH = "full_path",
  CHILDREN_ONLY = "children_only",
}
export const RedoFinderLoadTypeSchema = createEnum(RedoFinderLoadType);
